import React, { useState } from 'react';
import { Controller, Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import TrackSliders from './TrackSliders';

import AmbienceSliders from './AmbienceSliders';
import Effects from './Effects';
import LiveRadio from './LiveRadio';

const SliderSwiper: React.FC = () => {
    const [headerSwiper, setHeaderSwiper] = useState<any>(null);
    const [mainSwiper, setMainSwiper] = useState<any>(null);
    return (
        <div className="w-full md:w-100">
            <Swiper
                slidesPerView="auto"
                onSwiper={setHeaderSwiper}
                modules={[Controller]}
                controller={{ control: mainSwiper }}
                height={200}
            >
                <SwiperSlide>
                    <p className="text-base04">Track Sliders</p>
                </SwiperSlide>
                <SwiperSlide>
                    <p className="text-base04">Ambience Sliders</p>
                </SwiperSlide>
                <SwiperSlide>
                    <p className="text-base04">Effects</p>
                </SwiperSlide>
            </Swiper>
            <Swiper
                modules={[Navigation, Controller]}
                slidesPerView="auto"
                navigation
                centeredSlides={true}
                controller={{ control: headerSwiper }}
                onSwiper={setMainSwiper}
            >
                <SwiperSlide>
                    <TrackSliders />
                </SwiperSlide>
                <SwiperSlide>
                    <AmbienceSliders />
                </SwiperSlide>
                <SwiperSlide>
                    <Effects />
                </SwiperSlide>
            </Swiper>
        </div>
    );
};

export default SliderSwiper;
